import { Box, Button, Grid, Paper, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import useStyles from "./style";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import siemens from "./img/siemens.jpg";
import hpe from "./img/hpe.jpg";
import awe from "./img/awe.jpg";
import { useState } from "react";
import Button2 from "../AdminModule/Dashboard/AdminDashboard/Button/index";
import {
  ALL_COHORT_NAMES_LIST,
  ALL_COHORT_ORGANIZATION_LIST,
  ALL_COHORT_PROGRAMS,
  ADMIN_DASHBOARD_SPOTLIGHT_LIST
} from "../common/constants/ApplicationUrl";
import api from "../common/dependencies/utils/Api";
import ModalFilter2 from "../common/modalFilter2";
import Slider from "react-slick";
import privateCohortBtn from "../../assets/svg/shield2.svg";
import axios from "axios";
import hashImage from "../../assets/images/hashImage.jpeg";
import swal from "sweetalert";
import Pagination from "react-js-pagination";
import {
  getPredefineOptionsList,
  getAdminDashSpotLightData,
  openLoader,
  closeLoader,
} from "../AdminModule/Dashboard/AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import "./styles.scss";
import Modal from "./Modal/modal";
import clsx from "clsx";

const AllCohortPrograms = (props) => {
  const topSpace =
  localStorage.getItem(
    "cohortWindow"
  );
  const { getAdminDashSpotLightData,spotLightDataList,  spotLightDataPaginate  } = props;
  const classes = useStyles();
  const history = useHistory();
  const [data, setData] = useState();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [paginationData, setPaginationData] = React.useState();
  const [filterFunction, setFilterFunction] = useState("");
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [cohortNameData, setCohortNameData] = useState();
  const [organizationNameData, setOrganizationNameData] = useState();
  const [filterCohortName, setFilterCohortName] = useState("");
  const [filterOrganizationName, setFilterOrganizationName] = useState("");
  const [toggleBtn, setToggleBtn] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("VERIFIED");
  const [allCohortsData, setAllCohortsData] = useState("");
  const [allCohortsPaginate, setAllCohortsPaginate] = useState("");
  const [modalVisibility2, setModalVisibility2] = useState();
  const getListDataFn = () => {
    props.openLoader();
    const listData = {};
    if (filterFunction.value) {
      listData.function = filterFunction.value;
    }
    if (filterIndustry.value) {
      listData.industry = filterIndustry.value;
    }
    if (filterStage.value) {
      listData.stage = filterStage.value;
    }
    if (filterOrganizationName.value) {
      listData.organization_name = filterOrganizationName.value;
    }
    if (filterCohortName.value) {
      listData.cohortId = filterCohortName.value;
    }

    // axios({
    //   url: ALL_COHORT_PROGRAMS,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //     sortKey: "name",
    //     sortOrder: "ASC",
    //     country: null,
    //     state: null,
    //     ...listData,
    //     searchField: null,
    //     searchKey: null,
    //     pageFilter: {
    //       currentPage: currentPage - 1,
    //       includeCount: true,
    //       pageSize: 9,
    //       sortField: "date_applied",
    //       sortOrder: "DESC",
    //     },
    //   },
    // })
    if(toggleBtn == 1)
    {
      let params = {
        cohortId: "",
        sortKey: "name",
        sortOrder: "ASC",
        country: null,
        state: null,
        ...listData,
        searchField: null,
        searchKey: null,
        pageFilter: {
          currentPage: currentPage - 1,
          includeCount: true,
          pageSize: 9,
          sortField: "date_applied",
          sortOrder: "DESC",
        },
      };
      api
      .POST(ADMIN_DASHBOARD_SPOTLIGHT_LIST,params)
      .then((res) => {
        setData(res.data?.data);
        setPaginationData(res.data?.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
    }
    else{
      api
      .POST(ALL_COHORT_PROGRAMS, {
        status: "VERIFIED",
        sortKey: "name",
        sortOrder: "ASC",
        country: null,
        state: null,
        ...listData,
        searchField: null,
        searchKey: null,
        pageFilter: {
          currentPage: currentPage - 1,
          includeCount: true,
          pageSize: 9,
          sortField: "date_applied",
          sortOrder: "DESC",
        },
      })
      .then((res) => {
        setData(res.data?.data);
        setPaginationData(res.data?.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  }
    
  };

  const getAllCohorts = () => {
    // axios({
    //   url: ALL_COHORT_NAMES_LIST,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //   },
    // })
    api
      .POST(ALL_COHORT_NAMES_LIST, {
        status: "VERIFIED",
      })
      .then((res) => {
        setCohortNameData(res.data?.data);
      })
      .catch((err) => {});
  };
  const getAllOrganizations = () => {
    // axios({
    //   url: ALL_COHORT_ORGANIZATION_LIST,
    //   method: "post",
    //   data: {},
    // })
    api
      .POST(ALL_COHORT_ORGANIZATION_LIST, {})
      .then((res) => {
        setOrganizationNameData(res.data?.data);
      })
      .catch((err) => {});
  };
  const initialAllCohorts = (status,pageNumber,cohortStatus) =>{
    const listData = {};
    if (filterFunction.value) {
      listData.function = filterFunction.value;
    }
    if (filterIndustry.value) {
      listData.industry = filterIndustry.value;
    }
    if (filterStage.value) {
      listData.stage = filterStage.value;
    }
    if (filterOrganizationName.value) {
      listData.organization_name = filterOrganizationName.value;
    }
    if (filterCohortName.value) {
      listData.cohortId = filterCohortName.value;
    }
    if(cohortStatus == 1)
    {
      let params = {
        cohortId: "",
        sortKey: "name",
        sortOrder: "ASC",
        country: null,
        state: null,
        ...listData,
        searchField: null,
        searchKey: null,
        pageFilter: {
          currentPage: pageNumber - 1,
          includeCount: true,
          pageSize: 9,
          sortField: "date_applied",
          sortOrder: "DESC",
        },
      };
      api
      .POST(ADMIN_DASHBOARD_SPOTLIGHT_LIST,params)
      .then((res) => {
        setData(res.data?.data);
        setPaginationData(res.data?.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
    }
    else{
    api
    .POST(ALL_COHORT_PROGRAMS, {
      status: status,
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      ...listData,
      searchField: null,
      searchKey: null,
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 9,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    })
    .then((res) => {
      setData(res.data?.data);
    //  if(cohortStatus == 0) setAllCohortsData(res.data?.data)
      setAllCohortsPaginate(res.data?.paginate)
      setPaginationData(res.data?.paginate);
      props.closeLoader();
    })
    .catch((err) => {
      props.closeLoader();
    });
  }
  }
  useEffect(() => {
    getListDataFn();
    initialAllCohorts("VERIFIED",1,0);
    getAllCohorts();
    getAllOrganizations();
    props.getPredefineOptionsList();
  }, []);

  const handleClickOfFilter = () => {
    getListDataFn();
  };

  // React.useEffect(() => {
  //   getListDataFn();
  // }, [currentPage]);

  React.useEffect(() => {
    setCurrentPage(1);
    getListDataFn();
  }, [filterCohortName, filterOrganizationName]);

  const handleChangeOfPage = (pageNumber) => {
    setCurrentPage(pageNumber);
    // setTimeout(() => {
      initialAllCohorts(selectedStatus,pageNumber,toggleBtn)

    // }, 1000);
  };

  const removeFirstItem = (arr, label) => {
    let newArr = arr?.filter((item, index) => index !== 0);
    newArr?.unshift({ value: "", label: label });
    return newArr;
  };

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: data?.length > 2 ? 3 : data?.length,
    // slidesToShow:data?.engagement.length > 2 ? 3 : data?.engagement.length ,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    let params = {
      cohortId: "",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: "",
      function: "",
      stage: "",
      searchField: "",
      searchKey: null,
      status: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 9,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getAdminDashSpotLightData(params);
  }, []);

  // useEffect(() => {
  // console.log("spotLightDataList",spotLightDataList)
  // }, [spotLightDataList])
  

  return (
    <Box className={topSpace !== undefined && topSpace !== null && topSpace !== "" && topSpace == "cohortsAll" ? classes.root:classes.root2}>
      <Modal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalData={modalData}
      />
      <Typography className={clsx(classes.heading, "homepageFirstHeader")}>
        Cohort-Based Programs
      </Typography>
      <Typography
        className={clsx(classes.paragraph, "homepageFirstDescription")}
      >
        Cohort-based programs {"(CBP)"} will be hosted on the mentorship portal
        in collaboration with partners from the startup ecosystem. Partners such
        as industry associations, incubators, accelerators, academia, various
        startup networks{" "}
        {"(for unicors, successful startups, professionals, etc.)"} etc. shall
        be able to host cohort-based, limited-duration mentorship programs on
        the portal. CBP can also be hosted during marquee events by Startup
        India such as Prarambh and SCO Startup Forum.
      </Typography>
      {modalVisibility2 && (
        <ModalFilter2
          modalVisibility={modalVisibility2}
          setModalVisibility={setModalVisibility2}
          // sendToParent={setIsParentData}
          showPurposeOfMentorship={true}
          fromPage={"startUpDashboard"}
          allCalendarData={true}
        />
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          marginTop: "1%",
        }}
      >
        <div
          className="dashboard-bottom-btn top-btn  newuserTooltip "
          onClick={() =>setModalVisibility2(true)}
          >
          <p
            style={{ cursor: "pointer", color: "white" }}
            className="createcohortsessionbtnpara"
          >
            COHORTS EVENTS CALENDAR
          </p>
          <span
            className="tooltiptext tooltip-bottom"
            style={{ left: "150px", top: "60px", width: "250px" }}
          >
            Click to View Cohorts Event Calendar
          </span>
        </div>
      </div>
      {/* <Box  className="filterContainer4"> */}
      <div className="newCohortListToogle">
        <div className="newuserTooltip">
          <Button2
            text="ALL COHORTS"
            className={
              toggleBtn !== 0
                ? "filter-button top-btn newcoloredbtn2  newBottomBtnWidth33 benheading"
                : "filter-button top-btn newcoloredbtn  newBottomBtnWidth33 benheading"
            }
            onClick={() => {
              setToggleBtn(0);
              setCurrentPage(1);
              setSelectedStatus("VERIFIED")
              initialAllCohorts("VERIFIED",1,0);
              // setData(allCohortsData);
              // setPaginationData(allCohortsPaginate);
            }}
          ></Button2>
          <span
            className="tooltiptext tooltip-bottom"
            style={{ left: "90px", top: "45px", width: "250px" }}
          >
            Click to View All Cohort
          </span>
        </div>
        <div className="newuserTooltip">
          <Button2
            text="COHORTS IN SPOTLIGHT"
            className={
              toggleBtn !== 1
                ? "filter-button top-btn newcoloredbtn2  newBottomBtnWidth33 benheading"
                : "filter-button top-btn newcoloredbtn  newBottomBtnWidth33 benheading"
            }
            onClick={() => {
              setToggleBtn(1);
              setCurrentPage(1);
              setData(spotLightDataList);
              setPaginationData(spotLightDataPaginate);
              setFilterOrganizationName("Select Organization Name");
              setFilterCohortName("Select Cohort Name");
              setFilterFunction("Select Function");
              setFilterIndustry("Select Industry")

            }}
          ></Button2>
          <span
            className="tooltiptext tooltip-bottom"
            style={{ left: "90px", top: "45px", width: "250px" }}
          >
            Click to View Cohorts in Spotlight
          </span>
        </div>
        <div className="newuserTooltip">
          <Button2
            text="PUBLIC COHORTS"
            className={
              toggleBtn !== 2
                ? "filter-button top-btn newcoloredbtn2  newBottomBtnWidth33 benheading"
                : "filter-button top-btn newcoloredbtn  newBottomBtnWidth33 benheading"
            }
            onClick={() => {
              setToggleBtn(2);
              setCurrentPage(1);
              setSelectedStatus("PUBLIC")
              // setData([])
              initialAllCohorts("PUBLIC",1,2);
              setPaginationData(null)
            }}
          ></Button2>
          <span
            className="tooltiptext tooltip-bottom"
            style={{ left: "90px", top: "45px", width: "250px" }}
          >
            Click to View Public Cohorts
          </span>
        </div>
        <div className="newuserTooltip">
          <Button2
            text="PRIVATE COHORTS"
            className={
              toggleBtn !== 3
                ? "filter-button top-btn newcoloredbtn2  newBottomBtnWidth33 benheading"
                : "filter-button top-btn newcoloredbtn  newBottomBtnWidth33 benheading"
            }
            onClick={() => {
              setToggleBtn(3);
              // setData(allCohortsData);
              setSelectedStatus("PRIVATE")
              setCurrentPage(1);
              initialAllCohorts("PRIVATE",1,3)
              // setPaginationData(allCohortsPaginate);
            }}
          ></Button2>
          <span
            className="tooltiptext tooltip-bottom"
            style={{ left: "90px", top: "45px", width: "250px" }}
          >
            Click to View Private Cohorts
          </span>
        </div>
      </div>
      {/* </Box> */}
      {/* <Box className="filterContainerNew">
        <Grid container spacing={1} alignItems="center">
          <div className="newuserTooltip">
            <Select
              className="orgselect"
              options={removeFirstItem(
                organizationNameData?.map((item) => ({
                  value: item.id,
                  label: item.name,
                })),
                "Select Organization"
              )}
              placeholder="Organization Name"
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterOrganizationName(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "105px", top: "46px", width: "160px" }}
            >
              Search Organization
            </span>
          </div>
          <Grid
            item
            xs={8}
            md={3}
            className={[
              classes.selectContainer,
              "newuserTooltip",
              "desktopviewcohort",
            ]}
          >
            <Select
              className={classes.select}
              options={removeFirstItem(
                cohortNameData?.map((item) => ({
                  value: item.id,
                  label: item.name,
                })),
                "Select Cohort"
              )}
              placeholder="Cohort Name"
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterCohortName(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "105px", top: "46px", width: "160px" }}
            >
              Search Cohort
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Select Industry"
              options={removeFirstItem(
                props.selectOptions?.industry_options,
                "Select Industry"
              )}
              onChange={(selected) => setFilterIndustry(selected)}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "120px", top: "47px", width: "130px" }}
            >
              Search Industry
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Select Function"
              options={removeFirstItem(
                props.selectOptions?._specialisation,
                "Select Function"
              )}
              onChange={(selected) => setFilterFunction(selected)}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "120px", top: "47px", width: "130px" }}
            >
              Search Function
            </span>
          </Grid>
          
        </Grid>
        <div
          className="newuserTooltip top-btn"
          style={{ position: "relative", right: "2.5%" }}
        >
          <Button
            variant="contained"
            style={{
              // marginLeft: "10px",
              fontFamily: "Montserrat",
              color: "#fff",
              fontSize: "16px",
              cursor: "pointer",
              backgroundColor: "#3ac2d7",
            }}
            className="gobtncohortfilter"
            onClick={handleClickOfFilter}
          >
            GO
          </Button>
          <span className="tooltiptext filter  tooltip-bottom">
            Click to Apply Filters
          </span>
        </div>
      </Box> */}
      {/* <Grid
            item
            xs={12}
            md={3}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Select Stage"
              options={removeFirstItem(
                props.selectOptions?.stage_of_startup_options,
                "Select Stage"
              )}
              onChange={(selected) => setFilterStage(selected)}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "120px", top: "47px", width: "130px" }}
            >
              Search Stage
            </span>
          </Grid> */}
      <Paper className={classes.cardsContainer} elevation={0}>
        <Typography className={clsx(classes.heading, "homepageFirstHeader")}>
          {toggleBtn == 0
            ? "All Cohorts "
            : toggleBtn == 1
            ? "Cohorts in Spotlight"
            : toggleBtn == 2
            ? "Public Cohorts "
            : "Private Cohorts"}
        </Typography>
        <Typography
          style={{
            textAlign: "right",
            marginBottom: "10px",
            padding: "0  7%",
            fontFamily: "Montserrat",
            color: "rgba(0,0,0,0.5)",
            fontWeight: "bold",
          }}
        >
          {
            paginationData !== undefined && paginationData !== null && paginationData !== "" && 
            <>
               {`Total Programs: ${
            paginationData ? parseInt(paginationData.totalElements) : ""
          } < ${paginationData?.currentPage} of ${paginationData?.numPages} >`}
            </>
          }
       
        </Typography>
        <Grid className={classes.mainCardContainer} container spacing={2}>
        {
         ( data == undefined || data == null || data == "" 
            ) &&
            <div className="emptyListCohort">
              No records found
            </div>
          }
          {
          data?.map((item, index) => (
            <Grid
              item
              xs={4}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              className="desktopviewcohort"
            >
              <div className="newuserTooltip">
                <img
                  src={item?.uploadBanner || hashImage}
                  style={{
                    height: "230px",
                    width: "380px",
                    maxWidth: "410px",
                    maxHeight: "none",
                    maxWidth: "none",
                    objectFit: "cover",
                    margin: "auto",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setModalData(item);
                    setModalOpen(true);
                  }}
                />
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{
                    left: "165px",
                    top: "196px",
                    width: "145px",
                  }}
                >
                  View Cohort Details
                </span>
              </div>
              <div className="newuserTooltip">
               
                <h4
                  style={{
                    fontSize: "20px",
                    cursor: "pointer",
                    display: "block",
                    marginTop:"15px"
                  }}
                  onClick={() => {
                    setModalData(item);
                    setModalOpen(true);
                  }}
                  className="homepageFirstDescription"
                >
                  {item?.program_name?.length > 25 ? (
                    <div className="tooltipicon">
                      {item?.program_name.slice(0, 25)}
                      <b style={{ cursor: "pointer" }}>...</b>
                      <span className="tooltiptext7" style={{ top: "-105px" }}>
                        {item?.program_name}
                      </span>
                    </div>
                  ) : (
                    item?.program_name
                  )}
                </h4>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{
                    left: "165px",
                    top: "25px",
                    width: "145px",
                  }}
                >
                  View Cohort Details
                </span>
                <p
                  style={{
                    fontFamily: "Montserrat",
                    fontSize: "1.1rem",
                    color: "rgb(62, 74, 89)",
                    height: "52.81px",
                  }}
                  className="homepageFirstDescription"
                >
                  {item?.program_desc?.length > 100 ? (
                    <>
                      <div className="d-flex">
                        <div>{item?.program_desc.slice(0, 100) + " ..."}</div>
                      </div>
                    </>
                  ):<>
                     <div className="d-flex">
                        <div>{item?.program_desc}</div>
                      </div>
                  </>}
                </p>
              </div>

              

              <div className="newuserTooltip top-btn">
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#644b9f",
                    color: "white",
                    fontFamily: "Montserrat",
                    padding: "0px 30px",
                    borderRadius: "20px",
                    marginTop: "40px",
                    minHeight: "2.75vh",
                    maxWidth: "14vw",
                    textTransform:"capitalize",
                    minWidth:"12rem",
                  }}
                  onClick={() => {
                    const value =
                      localStorage.getItem(
                        "SavedLoggedInData"
                      );
                    if (!value) {
                      // swal(
                      //   "Login Required!",
                      //   "Please Login with Mentor or Startup Credentials to Join A Cohort",
                      //   "info"
                      // );
                      // window.open(`/login`);
                      history.push({
                        pathname: "/login",
                        state: {
                          cohortId: item?.id,
                          role: "mentor2",
                        },
                      });
                      localStorage.setItem(
                        "clickcohortid",
                        item?.id
                      );
                    } else {
                      // window.open(
                      //   `/cohort-programs/all/${item?.id}`,
                      //   "_blank"
                      // );
                      localStorage.setItem("cohortWindow", "cohortsAll");
                      window.open(
                        `/cohort-programs/cohortView/${item?.id}`,
                        "_blank"
                      );
                    }
                  }}
                >
                  {
                    !item?.cohortVisibility &&
                    // <div className="newuserTooltip">
                    <img className="newCohortImgBtn" src={privateCohortBtn} />
                    
                    // <span
                    //       className="tooltiptext   tooltip-bottom"
                    //       style={{
                    //         left: "8px",
                    //         width: "160px",
                    //         height: "30px",
                    //         top: "4rem",
                    //       }}
                    //     >
                    //       Private Cohort
                    //     </span>
                    //     </div>

                  }
                
                  Read More 
                </Button>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{ left: "174px", top: "95px", width: "245px" }}
                >
                                         {!item?.cohortVisibility ? "Private Cohort, Click to Read More " : "Public Cohort, Click to Read More"} 

                </span>
              </div>
            </Grid>
          ))}
         
          {/* <Typography
                style={{
                  fontFamily: "Montserrat",
                  fontSize: "1.1rem",
                  color: "#3e4a59",
                  height: "52.81px",
                }}
                className="homepageFirstDescription"
              >
                {item?.program_desc?.slice(0, 69)}
                {item?.program_desc?.length > 69 && "..."}
              </Typography> */}
           {/* <Typography
                  style={{
                    fontFamily: "Montserrat",
                    fontSize: "20px",
                    color: "#3e4a59",
                    fontWeight: "600",
                    textAlign: "center",
                    marginTop: "10px",
                    display: "block",
                    cursor: "pointer",
                    height:
                      index === 3 ||
                      index === 5 ||
                      index === 6 ||
                      index === 7 ||
                      index === 8
                        ? "60px"
                        : "auto",
                  }}
                  onClick={() => {
                    setModalData(item);
                    setModalOpen(true);
                  }}
                  className="homepageFirstDescription"
                >
                  {item?.program_name.length > 36
                    ? item?.program_name.slice(36) + "..."
                    : item?.program_name}
                </Typography> */}
        </Grid>
        <div className="row justify-content-center pt-50 pb-50 mobileviewcohort">
          <Slider {...settings}>
            {/* <div className="container"> */}
            {data?.map((item, index) => {
              return (
                <div>
                  <div style={{ padding: "10px", marginBottom: "40px" }}>
                    <div class="prog-img position-relative overflow-hidden">
                      <img
                        class="img-fluid w-100"
                        src={item?.uploadBanner || hashImage}
                        style={{
                          width: "100% !important",
                          height: "auto",
                          objectFit: "cover",
                        }}
                        alt=""
                      />
                      <span class="pro-title position-absolute">
                        Siemens Solutions for Industry Verticals
                      </span>
                    </div>
                    <div class="img-decrp">
                      <h4
                        style={{
                          fontSize: "20px",
                        }}
                      >
                        {item?.program_name}
                      </h4>
                      <p
                        style={{
                          fontFamily: "Montserrat",
                          fontSize: "1.1rem",
                          color: "rgb(62, 74, 89)",
                        }}
                      >
                        {item?.program_desc?.slice(0, 69)}
                        {item?.program_desc?.length > 69 && "..."}
                      </p>
                    </div>
                    <div className="newuserTooltip top-btn">
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#644b9f",
                          color: "white",
                          fontFamily: "Montserrat",
                          padding: "0px 30px",
                          borderRadius: "20px",
                          // marginTop: "5px",
                          marginTop: "25px",
                          textTransform:"capitalize"
                        }}
                        onClick={() => {
                          const value =
                            localStorage.getItem(
                              "SavedLoggedInData"
                            );
                          if (!value) {
                            // swal(
                            //   "Login Required!",
                            //   "Please Login with Mentor or Startup Credentials to Join A Cohort",
                            //   "info"
                            // );
                            // window.open(`/login`);
                            history.push({
                              pathname: "/login",
                              state: {
                                cohortId: item?.id,
                                role: "mentor2",
                              },
                            });
                            localStorage.setItem(
                              "clickcohortid",
                              item?.id
                            );
                          } else {
                            localStorage.setItem("cohortWindow", "cohortsAll");
                            window.open(
                              `/cohort-programs/cohortView/${item?.id}`,
                              "_blank"
                            );
                            // window.open(
                            //   `/cohort-programs/all/${item?.id}`,
                            //   "_blank"
                            // );
                          }
                        }}
                      >
                         {
                    !item?.cohortVisibility &&
                    <img className="newCohortImgBtn " src={privateCohortBtn} />

                  }
                        Read More
                      </Button>
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{
                          left: "174px",
                          top: "35px",
                          width: "245px",
                        }}
                      >
                                         {!item?.cohortVisibility ? "Private Cohort, Click to Read More " : "Public Cohort, Click to Read More"} 
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
        <div className="pagination-box" style={{ marginTop: "30px" }}>
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={paginationData?.pageSize}
            totalItemsCount={paginationData?.totalElements}
            pageRangeDisplayed={5}
            onChange={handleChangeOfPage.bind(this)}
          />
        </div>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  selectOptions: state.AdminMentorListReducer.getPredefineOptionsList.list,
  spotLightDataList: state.AdminMentorReducer.spotLightAdminList.data,
  spotLightDataPaginate: state.AdminMentorReducer.spotLightAdminList.paginate,

});

export default connect(mapStateToProps, {
  openLoader,
  closeLoader,
  getPredefineOptionsList,
  getAdminDashSpotLightData,
})(AllCohortPrograms);